import { useNavigate } from 'react-router-dom'
import useFeatures, { Features } from './useFeatures'
import { useEffect } from 'react'

interface AccessControlProps {
  children: JSX.Element
  features: Features[]
  onNoAccess?: () => void
}

const AccessControl = ({
  children,
  features,
  onNoAccess,
}: AccessControlProps) => {
  const featuresObject = useFeatures()

  const navigate = useNavigate()

  useEffect(() => {
    features.forEach((feature) => {
      if (featuresObject[feature]) {
        return
      }
      if (onNoAccess) {
        onNoAccess()
      } else {
        navigate('/')
      }
    })
  }, [featuresObject])

  return children
}

export default AccessControl
